/**
 * PDF Text Selection Utility
 * Handles text selection from PDF viewer for User-Defined Fields
 */

export async function getSelectedPdfText(): Promise<string> {
  const sel = window.getSelection();
  const text = sel ? sel.toString().trim() : '';
  return text;
}

export function setupPdfTextSelection(
  onTextSelected: (text: string) => void
): () => void {
  const handleSelection = () => {
    const text = window.getSelection()?.toString().trim();
    if (text) {
      onTextSelected(text);
    }
  };

  // Add event listeners for text selection
  document.addEventListener('mouseup', handleSelection);
  document.addEventListener('keyup', handleSelection);

  // Return cleanup function
  return () => {
    document.removeEventListener('mouseup', handleSelection);
    document.removeEventListener('keyup', handleSelection);
  };
}
